export const TYPOGRAPHY_WEIGHTS = {
    strong: ['font-semibold'],
    medium: ['font-medium'],
    normal: ['font-normal'],
};
